<script>
	import {
		Bar
	} from 'vue-chartjs'
	export default {
		extends: Bar,
		props: ['data', 'names'],
		data() {
			return {
				colors: [  "#4caf50",
        "#6574cd",
        "#9561e2",
        "#f66D9b",
        "#4dc0b5",
        "#6cb2eb",
        "#34495e"],
				chartData: {
					labels: [],
					datasets: []
				}
			}
		},
		mounted() {			
			
			let i=0;
			for (const key in this.data) {
				if (this.data.hasOwnProperty(key) && this.names.indexOf(key) > -1) {	
						let value = (this.data[key] == '資料更新中') ? 0 : this.data[key];
						let dataset = {label: key, backgroundColor:this.colors[i], data:[parseInt(value)]};
						// console.log("dataset data", dataset);
						this.chartData.datasets.push(dataset);
						i++;
				}
			}
			
			let options = {
				title: {
					display: true,
					text: "學歷及專業教育文憑佔全校教師人數的百份比%"
				},
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true
						}
					}],							
				},
				responsive: true,
				maintainAspectRatio: true
			};
			this.renderChart(this.chartData, options);
		}
	}
</script>

<style scoped>
	/* .small {
    max-width: 600px;
    margin:  150px auto;
  } */
</style>


// WEBPACK FOOTER //
// resources/js/chart/Qualifications.vue